import styled, { css } from "styled-components";

import { Flex } from "@similarweb/ui-components/foundations";

const GRADIENT_BORDER = "linear-gradient(to right, #3e74fe, #2ad3ab)";
const GRADIENT_DEFAULT_TEXT = "linear-gradient(to right, #3e74fe 95%, #2ad3ab 100%)";
const GRADIENT_HOVER_BG = "linear-gradient(to right, #ebf1fe, #eafbf7)";
const GRADIENT_PRESSED_BG = "linear-gradient(to right, #d8e3fe, #d4f7ee)";
const GRADIENT_HOVER_TEXT = "linear-gradient(to right, #2d54b8 95%, #1d9f83 100%)";
const GRADIENT_COLLAPSED_BORDER =
    "radial-gradient(ellipse at top right, #02c79e 0%, #03c2a2 17%, #06b4af 37%, #0b9cc4 59%, #127be1 81%, #195afe 100%)";

const gradientBorderBase = css`
    position: relative;
    border: none;

    &::before {
        content: "";
        position: absolute;
        inset: 0;
        border-radius: 4px;
        padding: 1px;
        mask:
            linear-gradient(#fff 0 0) content-box,
            linear-gradient(#fff 0 0);
        mask-composite: exclude;
        pointer-events: none;
    }
`;

export const Wrapper = styled(Flex)<{ isCollapsed: boolean }>`
    overflow: hidden;
    align-items: center;
    flex-wrap: nowrap;
    gap: 8px;
    width: ${({ isCollapsed }) => (isCollapsed ? "30px" : "100%")};
    height: 30px;
    padding: ${({ isCollapsed }) => (isCollapsed ? "0" : "7px 11px")};
    justify-content: ${({ isCollapsed }) => (isCollapsed ? "center" : "flex-start")};
    margin-top: 10px;
    margin-left: 0;

    border-radius: 4px;
    cursor: pointer;
    background: transparent;

    ${gradientBorderBase}

    &::before {
        background: ${({ isCollapsed }) => (isCollapsed ? GRADIENT_COLLAPSED_BORDER : GRADIENT_BORDER)};
    }

    &:hover {
        background: ${({ isCollapsed }) => (isCollapsed ? "transparent" : GRADIENT_HOVER_BG)};
    }

    &:active {
        background: ${({ isCollapsed }) => (isCollapsed ? "transparent" : GRADIENT_PRESSED_BG)};
    }

    transition:
        width 200ms ease-in-out,
        padding 200ms ease-in-out,
        margin-left 200ms ease-in-out,
        background 150ms ease-in-out;

    transition-delay: ${({ isCollapsed }) => (isCollapsed ? "250ms" : "0")};
`;

export const IconWrapper = styled.div<{ isCollapsed: boolean }>`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: ${({ isCollapsed }) => (isCollapsed ? "20px" : "16px")};
    height: ${({ isCollapsed }) => (isCollapsed ? "20px" : "16px")};
    margin-left: ${({ isCollapsed }) => (isCollapsed ? "10px" : "0")};

    svg {
        display: block;
        width: 100%;
        height: 100%;
    }

    ${Wrapper}:hover & svg path {
        fill: url("#ai-studio-grad-hover");
    }

    ${Wrapper}:active & svg path {
        fill: url("#ai-studio-grad-hover");
    }
`;

export const Text = styled.span<{ isCollapsed: boolean }>`
    font-family: "DM Sans", sans-serif;
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    letter-spacing: 0;
    white-space: nowrap;

    background: ${GRADIENT_DEFAULT_TEXT};
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;

    opacity: ${({ isCollapsed }) => (isCollapsed ? 0 : 1)};
    width: ${({ isCollapsed }) => (isCollapsed ? 0 : "auto")};
    overflow: hidden;
    transition:
        opacity 200ms ease-in-out,
        width 200ms ease-in-out;
    transition-delay: ${({ isCollapsed }) => (isCollapsed ? "200ms" : "0")};

    ${Wrapper}:hover & {
        background: ${GRADIENT_HOVER_TEXT};
        -webkit-background-clip: text;
        background-clip: text;
    }

    ${Wrapper}:active & {
        background: ${GRADIENT_HOVER_TEXT};
        -webkit-background-clip: text;
        background-clip: text;
    }
`;
